import type { YammerState } from '../../state/types';
import type { ThunkDispatch } from '../../types';
import { getExperimentTreatment, getPersistedExperimentTreatment } from '../experiments/selectors';

import type { FeedConfigSetAction, PartialFeedConfig } from './actions.types';
import { threadCountExperimentFeedTypes } from './actions.types';

type FeedConfigSet = (feedConfig: PartialFeedConfig) => FeedConfigSetAction;
export const feedConfigSet: FeedConfigSet = (feedConfig) => ({
  type: 'FEED_CONFIG.SET',
  payload: { feedConfig },
});

const getThreadCountsByFeedType = (threadCount: number) =>
  threadCountExperimentFeedTypes.reduce((acc, feedType) => ({ ...acc, [feedType]: threadCount }), {});

type SetFeedThreadCountsForExperiment = (
  dispatch: ThunkDispatch,
  threadCount: number,
  loadOlderThreadCount: number
) => void;
const setFeedThreadCountsForExperiment: SetFeedThreadCountsForExperiment = (
  dispatch,
  threadCount,
  loadOlderThreadCount
) =>
  dispatch(
    feedConfigSet({
      threadCounts: getThreadCountsByFeedType(threadCount),
      loadOlderThreadCounts: getThreadCountsByFeedType(loadOlderThreadCount),
    })
  );

type SetFeedConfigForThreadCountExperiment = (dispatch: ThunkDispatch, getState: () => YammerState) => void;
export const setFeedConfigForThreadCountExperiment: SetFeedConfigForThreadCountExperiment = (dispatch, getState) => {
  const state = getState();
  const threadCount = getExperimentTreatment(state, 'FeedLoadNumThreads');
  const loadOlderThreadCount = getExperimentTreatment(state, 'FeedLoadMoreNumThreads');

  setFeedThreadCountsForExperiment(dispatch, threadCount as number, loadOlderThreadCount as number);
};

type ConfigureFeedThreadCountsForPersistedExperiment = (
  dispatch: ThunkDispatch,
  persistConfigKey: string
) => Promise<void>;
export const configureFeedThreadCountsForPersistedExperiment: ConfigureFeedThreadCountsForPersistedExperiment = async (
  dispatch,
  key
) => {
  const threadCountPromise = getPersistedExperimentTreatment(key, 'FeedLoadNumThreads');
  const loadOlderThreadCountPromise = getPersistedExperimentTreatment(key, 'FeedLoadMoreNumThreads');
  const [threadCount, loadOlderThreadCount] = await Promise.all([threadCountPromise, loadOlderThreadCountPromise]);

  setFeedThreadCountsForExperiment(dispatch, threadCount as number, loadOlderThreadCount as number);
};
